import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../../../utils/utils";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { Router } from "@angular/router";
import { DialogService } from "../../../../services/dialog.service";
import { CustomDialogService } from "../../../../services/customdialog.service";
import { MatDialog } from "@angular/material/dialog";
import { MatChipInputEvent } from "@angular/material/chips";
import { ToastrService } from "ngx-toastr";
import { PeQuarterReportingListComponent, SearchItem} from "./pe-quarterreporting-list.component";
import { FilterPopupComponent } from "../../shared-components/filterpopup/filterpopup.component";
import { TaxPeConfigurationService } from "../../../../services/tax-peconfiguration.service";
import { FiscalYearUtils } from "../../../../utils/fiscal-year.utils";

@Component({
    selector: "pe-quarterreporting",
    templateUrl: './pe-quarterreporting.component.html',
    styleUrls: ['./pe-quarterreporting.component.less', '../../../../style/container-tab-list.component.less', '../../../../style/new-generic-styles.component.less'],
    standalone: false
})

export class PeQuarterReportingComponent implements OnInit, OnDestroy {

    @ViewChild(PeQuarterReportingListComponent) actualRepSelList: PeQuarterReportingListComponent = {} as PeQuarterReportingListComponent;
    isReleaseActive: boolean = false;
    releaseButtonText: string = 'Initiate Release';

    isRevokeActive: boolean = false;
    revokeButtonText: string = 'Initiate Revoke';

    title: string;
    isEditModeEnabled = false;
    isExcelModeEnabled = false;
    isApprovalModeEnabled = false;
    isShowAllEnabled = true;

    subscriptionManagementId: any;
    subscriptionFiscalYear: any;
    subscriptionQuarter: any;
    subscriptions: any[] = [];

    list: TaxKpiManagement[] = [];
    @ViewChild(PeQuarterReportingListComponent, { static: false }) listComponent!: PeQuarterReportingListComponent;

    // Filter section
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    filter: string = '';
    isAllLoaded = false;
    waitHeader = `   -  **Please, wait until all breakdowns are properly loaded**`;
    reportingDeadlineBanner = 'Please be reminded that Data Entry/Release shall be done latest by 08th Working Date as per German calendar'
    columnsToDisplay2 = ['ItemNo', 'COL1', 'COL2', 'COL3', 'COL4', 'ValueM3', 'ValueM2', 'ValueM1', 'Value', 'Budget', 'actions'];

    showReleaseLabel = false;
    isActive: boolean = false;
    peConfigLoaded: boolean = false;

    constructor(
        public defaults: DefaultValuesService
        , private http: HttpClient
        , private dialogForm: MatDialog
        , private dialog: DialogService
        , @Inject('BASE_URL') private baseUrl: string
        , private router: Router
        , private customDialog: CustomDialogService
        , private toastrService: ToastrService
        , private readonly taxPeConfigurationService: TaxPeConfigurationService

    ) {
        this.title = `TAX - Quarterly Actual Reporting (${this.defaults.managementName} - ${this.defaults.fiscalYear - 1}/${this.defaults.fiscalYear} - Quarter ${this.defaults.quarterId})`;
    }

    ngOnInit() {
        this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => { 
            this.loadPeConfiguration();
            this.loadInformation(true);
        });
        this.subscriptionFiscalYear = this.defaults.fiscalYearMessageChanges$.subscribe(() => { this.loadInformation(true) });
        this.subscriptionQuarter = this.defaults.quarter$.subscribe(() => { this.loadInformation(true) });
        if (this.defaults.managementids.length !== 0) {
            this.loadInformation(true);
            this.loadPeConfiguration(); 
        }
    }

    ngOnDestroy() {
        this.subscriptionManagementId.unsubscribe();
        this.subscriptionFiscalYear.unsubscribe();
        this.subscriptionQuarter.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    onClickSave() {
        // Check for incorrect hours or units values
        if (this.listComponent.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'UNITS' || x.KpiUnit?.toUpperCase() === 'HOURS')
            && x.KpiValue.indexOf('.00') < 0).length > 0) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect value provided with decimals for a Units or Hours KPI.' } });
            return;
        }
        // Check for incorrect decimal value
        if (this.listComponent.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'DECIMAL')
            && this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits) === false).length > 0) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect decimal value provided' } });
            return;
        }
        // Check for incorrect currency values based on local currency
        if (this.listComponent.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'VALUES' || x.KpiUnit?.toUpperCase() === 'VALUE LC')
            && this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits) === false).length > 0) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect currency value provided.' } });
            return;
        }

        var wasAnyUpdate = this.listComponent.updatedItems.length > 0
        this.listComponent.updatedItems = this.listComponent.updatedItems.filter(x => x.KpiValue !== 'NaN')

        if (this.listComponent.updatedItems.length > 0) {
            Utils.httpUpdateTaxKpis(
                this.http,
                this.baseUrl,
                this.listComponent.updatedItems,
                this,
                function(tthis: PeQuarterReportingComponent){
                    tthis.loadInformation()
                    tthis.toastrService.success('Kpi values were updated successfully!');
                    tthis.isEditModeEnabled = false
                },
                function (tthis: PeQuarterReportingComponent, error: string) {
                    tthis.dialog.showErrorDialog(error);
                }
            );
        }
        else {
            this.isEditModeEnabled = false;
            if (wasAnyUpdate)
                this.loadInformation()
        }
    }

    onClickEdit() {
        if (this.isEditModeEnabled === true) {
            this.isEditModeEnabled = false
            if (this.listComponent.updatedItems.length > 0) {
                this.loadInformation()
            }
        }
        else {
            this.isEditModeEnabled = true
        }
    }

    onClickShowAllButton() {
        if (this.isShowAllEnabled === false) {
            this.isShowAllEnabled = true
        }
        else {
            this.isShowAllEnabled = false
        }
    }

    onClickReleaseMode() {
        var selectedRows = this.actualRepSelList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []

        this.customDialog.openConfirm({
            title: "Release Kpi values",
            message: `Do you want to release all populated values which are still pending? Please note that you cannot edit any values after the release!. `,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpReleaseTaxKpiDefinitions(
                    this.http
                    , this.baseUrl
                    , selectedRows
                    , true
                    , this
                    , function (tthis: PeQuarterReportingComponent) {
                        tthis.loadInformation();
                        tthis.toastrService.success('Kpi values were released successfully!');
                        tthis.toggleRelease();
                    }
                );
            }
        })
    }

    onClickRevoke() {
        var selectedRows = this.actualRepSelList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []
        this.customDialog.openConfirm({
            title: "Revoke KPI values",
            message: `Do you want to revoke all populated values for selected period?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpRevokeTaxKpiValues(
                    this.http
                    , this.baseUrl
                    , selectedRows
                    , true
                    , this
                    , function (tthis: PeQuarterReportingComponent) {
                        tthis.loadInformation();
                        tthis.toastrService.success('Kpi values were revoked successfully!');
                        tthis.toggleRevoke();
                    }
                );
            }
        })
    }

    onClickExcelButton() {
        this.isExcelModeEnabled = true;
    }

    onClickCancelButton() {
        this.isEditModeEnabled = this.isExcelModeEnabled = false;
    }

    isCorrectCurrencyValue(value: string, decimalDigits: number) {
        const dotIndex = value.indexOf('.');
        const colonIndex = value.indexOf(',');
        if (dotIndex === -1 && colonIndex === -1) {
            return true;
        }

        const maxSymbol = Math.max(dotIndex, colonIndex);
        if (maxSymbol === -1 || maxSymbol === value.length - 1) {
            return true;
        }
        return value.length - maxSymbol - 1 <= decimalDigits;
    }

    downloadExcelInformation() {

        let date = new Date()
        const year = date.getFullYear().toString(); // a�o
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // mes con dos d�gitos
        const day = date.getDate().toString().padStart(2, '0'); // d�a con dos d�gitos

        Utils.httpDownloadTaxActualReportingInformation(
            this.http
            , this.baseUrl
            , `${year}${month}${day}_${this.defaults.managementid}_${this.defaults.groupFunction}_${this.defaults.fiscalYear - 1}-${this.defaults.fiscalYear}_Q${this.defaults.quarterId}_TAX_ACT`
            , this.isShowAllEnabled
            , this
            , null
            , function (tthis: PeQuarterReportingComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
            });
    }

    goUploadFileView() {
            this.router.navigate(["file/" + Utils.getFileUploadTaxActualReportingInformation()]);
    }

    // Filter section

    auxFilterPredicate(filters: string, data: any, parentLevel: boolean, showAllEnabled: boolean): boolean {
        if (filters === '__FORCE__') {
            return parentLevel || showAllEnabled || !!(data.ValueM1 || data.ValueM2 || data.ValueM3 || data.ValueLocal || data.Budget);
        }
        const filterArray = filters.split('+').filter(x => x);
        return filterArray.every(filter => {
            if (parentLevel) {
                const kpiname = (data.KpiName || '').toLowerCase();
                const id = (data.AccountID || '').toLowerCase();
                return kpiname.includes(filter.toLowerCase()) || id.includes(filter.toLowerCase());
            } else {
                const granularity = (data.Granularity || '').toLowerCase();
                let result = granularity.includes(filter.toLowerCase());
                if (!showAllEnabled) {
                    result = result && !!(data.ValueM1 || data.ValueM2 || data.ValueM3 || data.ValueLocal || data.Budget);
                }
                return result;
            }
        });
    }

    public toggleRelease() {
        this.isReleaseActive = !this.isReleaseActive;
        this.releaseButtonText = this.isReleaseActive ? 'Abort Release' : 'Initiate Release', this.actualRepSelList.clearSelectionList()
    }

    public toggleRevoke() {
        this.isRevokeActive = !this.isRevokeActive;
        this.revokeButtonText = this.isRevokeActive ? 'Abort Revoke' : 'Initiate Revoke', this.actualRepSelList.clearSelectionList()
    }

    canUserRevoke() {
      return this.defaults.isMersyCDPTaxAdmin
        || this.defaults.isMersyCDPTaxRevoker
    }

    canUserRelease() {
      return this.canUserRevoke()
        || this.defaults.isMersyCDPTaxReporter
    }

    private loadInformation(canShowReleaseMenssage: boolean = false) {
        this.subscriptions.forEach(x => x.unsubscribe())
        this.showReleaseLabel = false;
        this.isAllLoaded = false;
        this.title = `TAX - Quarterly Actual Reporting (${this.defaults.managementName} - ${this.defaults.fiscalYear - 1}/${this.defaults.fiscalYear} - Quarter ${this.defaults.quarterId})`;
        let showMandatoryReleaseMessage = canShowReleaseMenssage && this.defaults.userCanReleaseMersy();
        Utils.httpGetTaxActualReportingInformation(
            this.http
            , this.baseUrl
            , this
            , function (tthis: PeQuarterReportingComponent, result: TaxKpiManagement[]) {
                setTimeout(() => {
                    //let fullyReleased = true;
                    result.forEach(x => {
                        if (!x.subtable) {
                            const row = x.KpiDetail[0]
                            let maxBreakdown = ''
                            let columns = Object.assign([], tthis.columnsToDisplay2);

                            if (row.COL4 === '') {
                                columns.splice(columns.indexOf('COL4'), 1)
                                maxBreakdown = 'COL3'
                            }
                            if (row.COL3 === '') {
                                columns.splice(columns.indexOf('COL3'), 1)
                                maxBreakdown = 'COL2'
                            }
                            if (row.COL2 === '') {
                                columns.splice(columns.indexOf('COL2'), 1)
                                maxBreakdown = 'COL1'
                            }
                            if (row.COL1 === '') {
                                columns.splice(columns.indexOf('COL1'), 1)
                                maxBreakdown = 'COL0'
                            }
                            x.columns = columns
                            x.maxBreakdown = maxBreakdown
                            tthis.showReleaseLabel = tthis.showReleaseLabel || x.ApprovalStatus === 'RELEASED'
                            //fullyReleased = fullyReleased && (x.KpiDetail.every(x => x.ApprovalStatus === '') || x.KpiDetail.every(x => x.ApprovalStatus === 'RELEASED'));
                        }
                    });
                    tthis.list = result
                    tthis.isAllLoaded = true;
                    //if (showMandatoryReleaseMessage && !fullyReleased) {
                    if (showMandatoryReleaseMessage) {
                        tthis.dialog.doBack = false;
                        tthis.dialog.messageFontSize = 22;
                        tthis.dialog.extraClasses = ['height_38vh', 'width_35vw', 'light-background'];
                        tthis.dialog.showSuccessDialog('Please be aware that the release of data is mandatory');
                    }
                }, 50)
            }
            , function (tthis: PeQuarterReportingComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
                tthis.list = [];
            }
        );
    }

    private loadPeConfiguration(): void {
        this.taxPeConfigurationService.getPeConfiguration(
            this,
            (tthis: PeQuarterReportingComponent, result: PeConfiguration) => {
                tthis.isActive = result.active;
                tthis.peConfigLoaded = true;
            },
            (tthis: PeQuarterReportingComponent, error: any) => {
                console.warn("Unable to load PE Configuration, defaulting to active", error);
                tthis.isActive = true;
                tthis.peConfigLoaded = true;
            }
        );
    }

    public isEditingAllowed(): boolean {
        if (this.isActive) return true;

        const isQ4 = FiscalYearUtils.isCurrentlyInQ4();
        if (!isQ4 || this.defaults.quarterId !== 4) return false;
        
        const currentFiscalYear = FiscalYearUtils.getCurrentFiscalYear();
        return this.defaults.fiscalYear === currentFiscalYear - 1;
    }
}
